export const mockedSessionAnalysis = `### Overview

You completed a mixed set of **MCCQE Part I**–style items spanning biostatistics, organ-system medicine, ethics, and psychiatry. Overall performance reflects solid recall of high-yield concepts and reasonable pacing across disciplines.

### Strengths

You showed strength where questions rewarded **interpretation of evidence** (for example, **P values** and what they do and do not imply) and **pattern recognition** in common clinical vignettes (e.g., **spondyloarthropathy**, **postpartum hemorrhage** with a **firm fundus**, **encopresis** with impaction). Ethics items that hinge on **consent and confidentiality** were handled in line with standard professional expectations.

### Weaknesses

Watch for **over-reading** vignettes (adding diagnoses or tests not supported by the stem) and for **exam traps** that pair plausible-sounding statistics language with incorrect definitions. In psychiatry, keep **personality disorder** criteria distinct from mood or psychotic disorders; in respirology, tie **percussion and air entry** tightly to **effusion vs pneumothorax**.

### Recommendations

Drill **biostatistics definitions** (P value, CI, power) with short verbal explanations. For **OB/GYN** and **pediatrics**, rehearse **alarm features** vs **classic bread-and-butter** presentations. Add **spaced repetition** on **psychiatry** diagnostic criteria and **pulmonary exam** findings.

### Key Takeaway

- **Biostatistics**: know what significance does **not** tell you (effect size, individual outcomes, replication).
- **Clinical**: use **pivotal exam clues** (fundal tone, unilateral dullness, LLQ mass) to narrow the field quickly.
- **Ethics**: default to **patient autonomy** and **consent** unless a clear **mandatory** exception applies.

Keep cycling weak topics; MCCQE rewards breadth with consistent, exam-style reasoning.`;
